<template>
  <div
    class="position-relative wrap-highlight lead fw-bold"
  >
    <template v-if="productId === 1">
      <span class="highlight highlight-blue-400"> Responsabilité&nbsp;civile </span>
      <span> professionnelle </span>
    </template>
    <template v-else-if="productId === 2">
      <span class="highlight highlight-pink-400">Responsabilité&nbsp;des
        dirigeants</span>
    </template>
    <template v-else-if="productId === 4">
      <span class="highlight highlight-yellow-400"> Chômage </span>
      <span> du dirigeant </span>
    </template>
    <template v-else-if="productId === 5">
      <span class="highlight highlight-green-400"> Cyber-risques </span>
    </template>
    <template v-else-if="productId === 9">
      <span class="highlight highlight-blue-300"> Homme&nbsp;clé </span>
    </template>
    <template v-else-if="productId === 13">
      <span class="highlight highlight-pink-300"> Déplacements </span>
      <span> professionnels </span>
    </template>
    <template v-else-if="productId === 16">
      <span class="highlight highlight-yellow-400"> Bureau&nbsp;/&nbsp;Local </span>
      <span>professionnel</span>
    </template>
    <template v-else-if="productId === 18">
      <span class="highlight highlight-green-300"> Mutuelle </span>
      <span>entreprise</span>
    </template>
    <template v-else-if="productId === 19">
      <span class="highlight highlight-blue-300"> Prévoyance </span>
      <span>entreprise</span>
    </template>
    <template v-else-if="productId === 29">
      <span class="highlight highlight-yellow-300"> Litiges&nbsp;sociaux </span>
    </template>
    <template v-else-if="productId === 42">
      <span class="highlight highlight-green-400"> Assurance&nbsp;télétravail </span>
    </template>
    <template v-else>
      {{ productName }}
    </template>
  </div>
</template>
<script>
export default {
  props: {
    productId: {
      type: Number,
      default: 1,
      required: true,
    },
    productName: {
      type: String,
      default: '',
    },
  },
};
</script>
<style scoped>
.wrap-highlight span + span {
  position: relative;
}
</style>
